import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { Link, Redirect } from "react-router-dom";
import { MaturityDashboardAdminView } from "./maturity-dashboard-admin-view";
export const MaturityDashboardAdminController = (props) => {
	
	
	const [result, setResult] = useState(0)


  if (1) {
    return <Redirect to="/educate-prepare-home" />;
  }
	
	
	
	
	
	
	//console.log("resp11",resp.loss)
  return <MaturityDashboardAdminView  lossprogresResult={result} {...props} />
};
